import React from "react";
import Hero from "../../components/Hero/Hero";
import Craftsmanship from "../../components/Craftsmanship/Craftsmanship";
import { ContactCards } from "../Contact/Contact";
import Testmonials from "../Testimonials/Testmonials";

const Home = () => {
  return (
    <div className="bg-linen min-h-screen">
      <Hero />
      <Craftsmanship />

      {/* Contact section — embedded on homepage with its own styled wrapper */}
      <section className="bg-linen py-14 md:py-20 px-6" id="contact">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-brass uppercase tracking-[0.2em] text-xs font-semibold block mb-3">Get In Touch</span>
            <h2 className="text-3xl md:text-5xl font-serif text-charcoal mb-3">Contact Our Team</h2>
            <p className="text-charcoal/60 font-sans text-sm md:text-base">Let us know how we can help.</p>
          </div>
          <ContactCards />
        </div>
      </section>

      <Testmonials />
    </div>
  );
};

export default Home;

